import store from "../store/store";
import { appActionTypes } from "./saga";
/**
 * @module AppSaga
 */

/**
 * set online status
 * @param {boolean} isOnline
 */

export function putOnline(isOnline) {
  store.dispatch({
    type: appActionTypes.PUT_ONLINE,
    payload: {
      online: isOnline
    }
  });
}

export function setNotificationPermission(notification, navigate) {
  store.dispatch({
    type: appActionTypes.PUT_NOTIFICATION_PERMISSION,
    payload: {
      notification,
      navigate
    }
  });
}

export function setFeatureFlags(featureFlags) {
  store.dispatch({
    type: appActionTypes.PUT_FEATURE_FLAGS,
    payload: {
      featureFlags
    }
  });
}

export function setIncidents(incidents) {
  store.dispatch({
    type: appActionTypes.PUT_INCIDENTS,
    payload: {
      incidents
    }
  });
}

export function setShouldListen(shouldListen) {
  store.dispatch({
    type: appActionTypes.SET_SHOULD_LISTEN,
    payload: {
      shouldListen
    }
  });
}
